<template>
  <div class="checkout-summary">
    <SimonModal
      :is-visible="showCtaModal"
      @hide="showCtaModal = false"
      id="cta-info-modal"
      custom-modal-class="info-modal modal-sim-substitute"
      show-footer-buttons
      :btn-left-title="getSlotText('btnCtaModalCancel', 'Abbrechen')"
      :btn-right-title="getSlotText('btnCtaModalConfirm', 'Bestätigen')"
      @btnLeft="closeActionModal()"
      @btnRight="order"
    >
      <template v-slot:modalTitle>
        <slot name="headerCtaModal"></slot>
      </template>
      <slot v-if="eSimIsSelected" name="contentCtaModal"></slot>
      <slot v-if="classicIsSelected" name="classicContentCtaModal"></slot>
    </SimonModal>

    <div class="content-card">
      <slot name="titleHeadline"></slot>
      <slot name="txtHeadline"></slot>
    </div>

    <div class="content-card text-before-summary-pua">
      <!-- Hier werden die Slots durchgereicht, ohne dass das 'ShoppingCart abgeschnitten wird.Damit die Slots aus dem mobilen Warenkorb wiederverwendet werden können.' -->
      <SimShoppingCartWrapper>
        <template v-for="slot in possibleChildSlotsFor('ShoppingCart')" v-slot:[`${slot.parent}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </SimShoppingCartWrapper>
    </div>

    <b-form
      :id="'form' + _uid"
      :novalidate="true"
      class="substitute-summary-step"
      ref="form">

      <div class="sim-card-data-content inline-info-box not-embedded">
        <slot name="titleHeaderBox1"></slot>

        <div class="summary-row first-row">
          <label><span><slot name="lblMsisdn"></slot></span></label>
          <div>
            <span class="msisdn">{{msisdnFormatted(currentCustomer.contract.msisdn)}}</span>
          </div>
        </div>

        <div class="summary-row">
          <label><span><slot name="lblSimFormat"></slot></span></label>
          <div>
            <span class="msisdn">{{formattedSimFormat}}</span>
          </div>
        </div>

        <div class="summary-row">
          <label><span><slot name="lblSimStatus"></slot></span></label>
          <div>
            <span class="msisdn">{{formattedSimActivation}} </span>
          </div>
        </div>
      </div>

      <!--      Wenn ESIM ausgewählt worden ist-->
      <div class="deliver-data-content inline-info-box not-embedded" v-if="eSimIsSelected">
        <slot name="titleHeaderBox2esim"></slot>
        <div class="summary-row first-row">
          <label><span><slot name="lblName"></slot></span></label>
          <div>
            <span class="first-name">{{currentCustomer.firstName}} </span>
            <span class="last-name">{{currentCustomer.lastName}}</span>
          </div>
        </div>
        <div class="summary-row">
          <label><span><slot name="lblEmail"></slot></span></label>
          <div>
            <span class="mail-address">
              {{currentCustomer.email}}
            </span>
          </div>
        </div>
        <div class="info-box-description">
          <slot name="infoBox2esim"></slot>
        </div>
      </div>

      <!--      Wenn klassisch ausgewählt worden ist -->
      <div class="deliver-data-content inline-info-box not-embedded" v-if="classicIsSelected">
        <slot name="titleHeaderBox2sim"></slot>
        <DeliveryInfoCard class="delivery-info-card second-delivery-card" :customer="currentCustomer">
          <template v-for="slot in possibleChildSlotsFor('DeliveryInfoCard')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </DeliveryInfoCard>
      </div>

      <div class="cards-wrapper">
        <div class="info-box" v-if="eSimIsSelected && !isFreeEsim"><slot name="infoBox1"></slot></div>
        <div class="info-box" v-if="eSimIsSelected && isFreeEsim"><slot name="infoBox1Free"></slot></div>
        <div class="info-box" v-if="classicIsSelected"><slot name="infoBox2"></slot></div>
      </div>

    </b-form>
    <Stepper
      @next="next()"
      :show-prev="true"
      @prev="back()"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>
<script>

import DeliveryInfoCard from '@/components/process/generic/SubstituteSimCard/DeliveryInfoCard.vue'
import SimShoppingCartWrapper from '@/components/process/wrapper/SelfService/SimCard/SimShoppingCartWrapper.vue'
import Stepper from '@/components/generic/Stepper.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import beErrors from '@/mixins/beErrors'
import { isValidPhoneExt, phoneNoExpExt } from '@/mixins/validators/phone'
import SimonModal from '@/components/modal/SimonModal.vue'

export const stepName = 'summary'

export default {
  name: 'SubstituteESimSummary',
  data () {
    return {
      loading: false,
      cancelVariant: 'secondary',
      okVariant: 'primary confirm',
      currentCustomer: {
        contract: {
          msisdn: '',
          simCard: {
            type: '',
            status: ''
          }
        },
        firstName: '',
        lastName: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          zip: ''
        },
        mail: ''
      },
      showCtaModal: false,
      pageTrackingDone: false
    }
  },
  computed: {
    ...mapGetters('substituteSimCard', [
      'getSelectionData', 'getSimCardOption', 'isFreeEsim', 'skippedSelection'
    ]),
    selectionData () {
      return this.getSelectionData
    },
    eSimIsSelected () {
      return this.getSelectionData.simType === 'E_SIM'
    },
    classicIsSelected () {
      return this.getSelectionData.simType === 'SIM_CARD'
    },
    isPreActivated () {
      return this.getSelectionData.activation === 'PREACTIVATED'
    },
    isCustomerActivated () {
      return this.getSelectionData.activation === 'BY_CUSTOMER'
    },
    formattedSimFormat () {
      if (this.eSimIsSelected) {
        return this.$slots.valueEsimFormat?.[0]?.text || 'eSIM'
      } else if (this.classicIsSelected) {
        return this.$slots.valueSimFormat?.[0]?.text || 'Klassische SIM-Karte'
      } else {
        return ''
      }
    },
    formattedSimActivation () {
      if (this.isPreActivated && this.eSimIsSelected) {
        return this.$slots.valueActiveEsim?.[0]?.text || 'Aktivierte SIM'
      } else if (this.isPreActivated && this.classicIsSelected) {
        return this.$slots.valueActiveSim?.[0]?.text || 'Aktivierte SIM'
      } else if (this.isCustomerActivated && this.classicIsSelected) {
        return this.$slots.valueInactiveSim?.[0]?.text || 'Inaktive SIM-Karte'
      } else {
        return ''
      }
    },
    formattedMsisdn () {
      if (this.currentCustomer.contract.msisdn) {
        return '+' + this.currentCustomer.contract.msisdn
      } else {
        return ''
      }
    },
    fallbackErrorMessage: function () {
      return this.getSlotText('txtToastError', 'Es ist ein technischer Fehler aufgetreten.')
    }
  },
  methods: {
    ...mapMutations('substituteSimCard', [
      'changeStep', 'setStep', 'setOrderStatus', 'setOrderId', 'setSelectedProductNumber'
    ]),
    ...mapActions('substituteSimCard', [
      'orderSubstituteESimCard'
    ]),
    next () {
      if (this.eSimIsSelected || (this.classicIsSelected && this.isPreActivated)) {
        this.showActionModal()
      } else {
        this.order()
      }
    },
    order () {
      const me = this
      let successUrl = ''
      if (this.eSimIsSelected) {
        successUrl = this.successUrlEsim
      } else if (this.classicIsSelected) {
        successUrl = this.successUrlSim
      }
      if (!this.getSimCardOption.productNumber) {
        me.$store.commit('addError', this.getSlotText('errorMsgNoProductNumber'))
        this.openErrorToast()
        return
      }
      this.startLoader()
      this.setSelectedProductNumber(this.getSimCardOption.productNumber)
      this.orderSubstituteESimCard().then((result) => {
        if (result) {
          this.setOrderStatus(result.success)
          this.setOrderId(result.orderHash)
          window.location.href = successUrl
          return
        }
        this.openErrorToast()
      }).finally(() => {
        this.stopLoader()
      })
    },
    showActionModal () {
      this.showCtaModal = true
      this.trackDeactivationReminder('reveal', 'system')
    },
    closeActionModal () {
      this.showCtaModal = false
      this.trackDeactivationReminder('close', 'icon')
    },
    back () {
      if (this.skippedSelection) {
        window.location.href = this.backLink
      } else {
        this.changeStep('selection')
      }
    },
    openErrorToast: function () {
      this.errorToast(this.errorMessage())
    },
    errorMessage () {
      const firstMessage = this.beErrorGetLastMessage()
      const firstCat = this.beErrorGetLastCategory()
      if (firstMessage && firstCat === 'graphql') {
        // technical error message, do not use for customer
        return this.fallbackErrorMessage
      }
      return firstMessage
    },
    msisdnFormatted (v) {
      let p = v.replace(/([^0-9+-])/g, '').trim()
      if (p !== '') {
        if (!isValidPhoneExt(p)) {
          // check if number starts with country code with missing 00 or +
          if (p.substring(0, 2) === '49') {
            p = '+' + p
          }
        }
        if (isValidPhoneExt(p)) {
          const partCountryCode = p.replace(phoneNoExpExt, '$2')
          const partPrefix = p.replace(phoneNoExpExt, '$5')
          const partNo = p.replace(phoneNoExpExt, '$6')
          let formatted = (partCountryCode + (partCountryCode !== '0' ? ' ' : '') + partPrefix + ' ' + partNo).trim()

          // ensure we have a country code prefix
          if (formatted.substr(0, 1) !== '+') {
            // replace a double zero
            if (formatted.substr(0, 2) === '00') {
              formatted = '+' + formatted.substr(2)
            } else if (formatted.substr(0, 1) === '0') {
              formatted = '+49' + formatted.substr(1)
            } else if (formatted.substr(0, 1) === '1') {
              formatted = '+49' + formatted
            }
          }

          p = formatted
        }
      } else {
        p = ''
      }
      return p
    },
    triggerTracking: function () {
      let propositions = ''
      if (typeof window.trackingNS?.track?.getSimSwapPropositions === 'function') {
        propositions = window.trackingNS.track.getSimSwapPropositions(this.getSimCardOption, this.getSelectionData)
      }
      const data = {
        page_levels: [
          'mein-simon',
          'meine-sim',
          'sim replacement',
          'summary'
        ],
        login_status: 'not logged in', // check/set in tracking
        page_type: 'checkout',
        platform_type: 'browser view',
        activation_method: this.getSelectionData.activation,
        shipping_price: this.getSimCardOption.shippingCosts,
        form: {
          name: 'sim replacement',
          step_name: 'summary',
          step: '2',
          type: 'order funnel'
        },
        propositions: propositions
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('pageview', data)
        this.pageTrackingDone = true
      }
    },
    trackDeactivationReminder: function (action, trigger) {
      if (typeof window.trackingNS?.track?.trackInformation === 'function') {
        window.trackingNS.track.trackInformation('deactivation reminder', action, 'overlay', trigger)
      }
    }
  },
  created () {
    this.setStep('summary')
  },
  mounted () {
    if (this.getSimCardOption && this.getSimCardOption.productNumber && this.getSimCardOption.productNumber !== '') {
      this.triggerTracking()
    }
  },
  watch: {
    getSimCardOption: function (v) {
      if (!this.pageTrackingDone && v && v.productNumber && v.productNumber !== '') {
        this.triggerTracking()
      }
    }
  },
  props: {
    backLink: {
      type: String,
      required: true
    },
    details: {
      type: Object,
      default: () => {}
    },
    successUrlSim: {
      type: String,
      default: ''
    },
    successUrlEsim: {
      type: String,
      default: ''
    }
  },
  components: {
    SimonModal,
    Stepper,
    DeliveryInfoCard,
    SimShoppingCartWrapper
  },
  mixins: [

    beErrors
  ],
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query orderSubstituteSim {
          currentCustomer {
            contract {
                msisdn
                simCard {
                  type
                  status
                }
            },
            firstName,
            lastName,
            address {
              city,
              houseNumber,
              street,
              zip
            },
            email
          }
        }`, this, 'currentCustomer', {}, () => {
          this.startLoader()
          this.stopLoader()
        }, {},
        (error) => {
          if (typeof error.message !== 'undefined') {
            const data = {
              type: 'technical',
              message: error.message
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.$emit('apollo-error')
        }
      )
    }
  }
}
</script>
